import React from 'react';
import PropTypes from 'prop-types';
import {withScriptjs, withGoogleMap, GoogleMap, Marker} from "react-google-maps"
import confConst from '../../../../config/const';

const MapComponent = withScriptjs(withGoogleMap((props) => {
    return (
      <GoogleMap
        zoom={+props.zoom}
        center={{...props.cords}}
      >
        {
          props.isMarkerShown &&
          <Marker
            position={{...props.cords}}
          />
        }
      </GoogleMap>
    )
  }
));


const Map = (props) => {
  let {zoom} = props;
  let cords = {...confConst.MAP.DEFAULT_CORDS};
  let isMarkerShown = false;

  if(props.cords && props.cords.lat && props.cords.lng){
    cords = {...props.cords};
    isMarkerShown = true;
  }

  if(!props.zoom){
    zoom = confConst.MAP.DEFAULT_ZOOM;
    zoom += 10
  }

  return (
    <MapComponent
      isMarkerShown={isMarkerShown}
      cords={{...cords}}
      zoom={zoom}
      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${confConst.MAP.KEY}&v=3.exp&libraries=geometry,drawing,places`}
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height: `400px` }} />}
      mapElement={<div style={{ height: `100%` }} />}
    />
  )
};

Map.propTypes = {
  cords: PropTypes.object,
  zoom: PropTypes.number,
};

export default Map



// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/Map/Map.js